/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const EmptyCommand = zod.looseObject({});

export type EmptyCommand = zod.input<typeof EmptyCommand>;
export type EmptyCommandOutput = zod.output<typeof EmptyCommand>;
